const DEFAULT_APP_HOST = 'www.glouton.app'

/**
 * Resolve a universal link or custom-scheme URL to an in-app Nuxt route path.
 */
export function resolveInAppPathFromUrl(
  url: string,
  appHost: string = DEFAULT_APP_HOST,
): string | null {
  try {
    const parsed = new URL(url)

    if (parsed.host === appHost) {
      const path = `${parsed.pathname}${parsed.search}${parsed.hash}`

      return path && path !== '/' ? path : null
    }

    if (parsed.protocol === 'ca.glouton.app:' || parsed.hostname === 'ca.glouton.app') {
      const path = `${parsed.pathname}${parsed.search}${parsed.hash}`

      return path && path !== '/' ? path : null
    }
  }
  catch {
    return null
  }

  return null
}
